import {useKioskoStore} from 'context/kiosko/useKioskoStore';

export type LayoutMode = 'default' | 'kiosko';

export const useLayoutMode = (): LayoutMode => {
  const isKioskoConnected = useKioskoStore(state => state.connection.isConnected);
  return isKioskoConnected ? 'kiosko' : 'default';
};
